import { FileInput, FileInputProps } from "@blueprintjs/core"
import React from "react"
import CustomFormGroup, { CustomFormGroupProps } from "./CustomFormGroup"

interface CustomFileInputProps extends CustomFormGroupProps, FileInputProps {}
const CustomFileInput = ({
  onInput,
  onClick,
  onSelect,
  buttonText,
  disabled,
  fill,
  hasSelection,
  inputProps,
  large,
  onInputChange,
  text,
  label,
  labelInfo,
  helperText,
  big,
  ...formGroup
}: CustomFileInputProps) => {
  return (
    <CustomFormGroup
      label={label}
      labelInfo={labelInfo}
      helperText={helperText}
      big={big}
      {...formGroup}
    >
      <FileInput
        onInput={onInput}
        onClick={onClick}
        onSelect={onSelect}
        className="vt-custom-file-input"
        buttonText={buttonText}
        disabled={disabled}
        fill={fill}
        hasSelection={hasSelection}
        inputProps={inputProps}
        large={large}
        onInputChange={onInputChange}
        text={text}
      />
    </CustomFormGroup>
  )
}

export default CustomFileInput
